import React, { Component } from 'react';
import Button from '../button/Button';

export default class TransparentButton extends Component {
	render() {
		return (
			<Button bg="transparent" color={this.props.color} {...this.props} border={this.props.border}>
				{this.props.children}
			</Button>
		);
	}
}
